/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertesEmplacementDto } from '../../models/alertes-emplacement-dto';

export interface GetAlertTemperatureByDkCodesEmplacements$Params {
  body: Array<string>;
}

export function getAlertTemperatureByDkCodesEmplacements(
  http: HttpClient,
  rootUrl: string,
  params: GetAlertTemperatureByDkCodesEmplacements$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AlertesEmplacementDto>> {
  const rb = new RequestBuilder(rootUrl, getAlertTemperatureByDkCodesEmplacements.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertesEmplacementDto>;
    })
  );
}

getAlertTemperatureByDkCodesEmplacements.PATH = '/v1/reportings_p1/alertes_emplacements';
